import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'white';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  icon,
  fullWidth,
  className,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-red text-white hover:bg-red-700 focus:ring-brand-red shadow-md hover:shadow-lg',
    secondary: 'bg-brand-navy text-white hover:bg-blue-900 focus:ring-brand-navy shadow-md hover:shadow-lg',
    outline: 'border-2 border-brand-navy text-brand-navy hover:bg-brand-navy hover:text-white focus:ring-brand-navy',
    ghost: 'text-brand-navy hover:bg-brand-lighter focus:ring-brand-navy',
    white: 'bg-white text-brand-navy hover:bg-gray-50 focus:ring-white shadow-md hover:shadow-lg'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2 gap-1.5',
    md: 'text-base px-6 py-3 gap-2',
    lg: 'text-lg px-8 py-4 gap-2.5'
  };
  const classes = twMerge(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className);
  if (href) {
    return <Link to={href} className={classes} data-id="element-370" data-mp="xnz5ifvmtbn5">
        {icon && <span className="shrink-0" data-id="element-371" data-mp="1cd50tsrcmhpr">{icon}</span>}
        {children}
      </Link>;
  }
  return <button className={classes} {...props} data-id="element-372" data-mp="17elcjlpa8tu8">
      {icon && <span className="shrink-0" data-id="element-373" data-mp="17f3jpddhgsgx">{icon}</span>}
      {children}
    </button>;
}